import { endpoint, dateToServer } from 'services/Api';
import { RESOURCE as PARENT } from 'services/api/miniCalculators';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'multipliers';

/**
 * Multipliers Mini Calculator Endpoints:
 */
export default {
    /**
     * Table E and F Calculation Endpoint.
     *
     * @param  {} state
     *
     * @return {Promise}
     */
    tableEandF(state) {
        return endpoint(`${PARENT}/${RESOURCE}`, 'table-e-and-f', {
            gender: state.gender,
            pre_or_post: state.preOrPost,
            age: state.ageOfDeceased,
            date_of_death: state.dateOfDeath,
            date_of_trial: state.dateOfTrialOrCessation
        });
    },
    /**
     * Ogden Table Info.
     *
     * @return {Promise}
     */
    ogdenTableInfo() {
        return endpoint(`${PARENT}/${RESOURCE}`, 'table-info');
    },
    /**
     * Lookup an Ogden table multiplier.
     *
     * @return {Promise}
     */
    lookupOgdenMultiplier(data) {
        return endpoint(`${PARENT}/${RESOURCE}`, 'lookup', data);
    },
};



// WEBPACK FOOTER //
// ./src/services/api/mini-calculators/multipliers.js